module.exports = __webpack_public_path__ + "media/images/proof_links/producthunt-5ba07eca798e37b925a6fa8ea6fd0420.svg";